/* Mélange Studio — minimal progressive enhancement.
   Everything here degrades to a working, navigable page with JS disabled. */
(function () {
  'use strict';

  /* Mega menu: hover on pointer devices, click/Escape everywhere. ---------- */
  var items = document.querySelectorAll('[data-nav-item]');
  var canHover = window.matchMedia('(hover: hover)').matches;
  // The mega menu spans the full page width while its trigger is one short
  // word, so any diagonal path to a link leaves the trigger's box. Closing on
  // a bare mouseleave made the submenu unreachable; wait, and cancel the close
  // if the pointer arrives anywhere in the menu.
  var closeTimer = null;
  var CLOSE_DELAY = 260;

  function closeAll(except) {
    items.forEach(function (el) {
      if (el !== except) {
        el.setAttribute('data-open', 'false');
        var b = el.querySelector('[data-nav-top]');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  }

  items.forEach(function (item) {
    var btn = item.querySelector('[data-nav-top]');
    if (!btn) return;

    function open(state) {
      item.setAttribute('data-open', String(state));
      btn.setAttribute('aria-expanded', String(state));
      if (state) closeAll(item);
    }

    btn.addEventListener('click', function (e) {
      if (!item.querySelector('.mega')) return;
      e.preventDefault();
      // On a hover device the menu is already open from mouseenter, so a click
      // that toggled would close it. Treat the click as "go to the category".
      if (canHover) {
        var url = btn.getAttribute('data-nav-url');
        if (url && url !== '#') { window.location.href = url; return; }
      }
      open(item.getAttribute('data-open') !== 'true');
    });

    if (canHover) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        open(true);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { open(false); }, CLOSE_DELAY);
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { clearTimeout(closeTimer); closeAll(null); }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-nav-item]')) { clearTimeout(closeTimer); closeAll(null); }
  });

  /* RTE tables: give each its own scroll container so a wide size chart never
     makes the page scroll sideways on mobile. ------------------------------ */
  document.querySelectorAll('.rte table').forEach(function (tbl) {
    if (tbl.parentElement.classList.contains('rte__table')) return;
    var w = document.createElement('div');
    w.className = 'rte__table';
    tbl.parentNode.insertBefore(w, tbl);
    w.appendChild(tbl);
  });

  /* Mobile drawer --------------------------------------------------------- */
  var drawer = document.querySelector('[data-drawer]');
  var burger = document.querySelector('[data-burger]');
  var drawerClose = document.querySelector('[data-drawer-close]');

  function setDrawer(state) {
    if (!drawer || !burger) return;
    drawer.setAttribute('data-open', String(state));
    burger.setAttribute('aria-expanded', String(state));
    document.body.style.overflow = state ? 'hidden' : '';
    if (state && drawerClose) drawerClose.focus();
    else if (!state) burger.focus();
  }

  if (burger) burger.addEventListener('click', function () {
    setDrawer(drawer.getAttribute('data-open') !== 'true');
  });
  if (drawerClose) drawerClose.addEventListener('click', function () { setDrawer(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.getAttribute('data-open') === 'true') setDrawer(false);
  });

  /* Facet + sort forms auto-submit ---------------------------------------- */
  var facetForm = document.querySelector('[data-facet-form]');
  if (facetForm) {
    facetForm.addEventListener('change', function () { facetForm.submit(); });
    var noscript = facetForm.querySelector('[data-facet-submit]');
    if (noscript) noscript.hidden = true;
  }

  var facetsPanel = document.querySelector('[data-facets]');
  var facetsToggle = document.querySelector('[data-facets-toggle]');
  if (facetsToggle && facetsPanel) {
    if (window.matchMedia('(max-width: 989px)').matches) {
      facetsPanel.setAttribute('data-collapsed', 'true');
    }
    facetsToggle.addEventListener('click', function () {
      var collapsed = facetsPanel.getAttribute('data-collapsed') === 'true';
      facetsPanel.setAttribute('data-collapsed', String(!collapsed));
      facetsToggle.setAttribute('aria-expanded', String(collapsed));
    });
  }

  /* Product gallery ------------------------------------------------------- */
  var main = document.querySelector('[data-gallery-main]');
  var thumbStrip = document.querySelector('[data-gallery-thumbs]');
  var featuredSrc = main ? main.src : '';
  var featuredAlt = main ? main.alt : '';

  // Assigned by the variant block below, once the variant map is parsed.
  var selectVariantByImage = null;

  function showMedia(thumb) {
    if (!main || !thumb) return;
    main.src = thumb.getAttribute('data-full');
    main.alt = thumb.getAttribute('data-alt') || '';
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', String(t === thumb));
    });
  }

  if (main) {
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(thumb);
        // Every variant has its own photograph, so picking one from the strip
        // is the shopper choosing that variant — keep the picker in step.
        if (selectVariantByImage) selectVariantByImage(thumb.getAttribute('data-full'));
      });
    });
  }

  /* +N reveals the thumbnails past the third. */
  var moreBtn = document.querySelector('[data-gallery-more]');
  if (moreBtn && thumbStrip) {
    moreBtn.addEventListener('click', function () {
      var collapsed = thumbStrip.getAttribute('data-collapsed') !== 'false';
      thumbStrip.setAttribute('data-collapsed', String(!collapsed));
      moreBtn.setAttribute('aria-expanded', String(collapsed));
      moreBtn.textContent = collapsed
        ? moreBtn.getAttribute('data-less-label')
        : moreBtn.getAttribute('data-more-label');
    });
  }

  /* Variant selection ------------------------------------------------------
     Reads the variant map rendered by main-product.liquid and keeps the
     hidden id input, price, stock line and Add-to-cart label in sync. */
  var form = document.querySelector('[data-product-form]');
  var mapEl = document.querySelector('[data-variant-map]');
  if (form && mapEl) {
    var variants;
    try { variants = JSON.parse(mapEl.textContent); } catch (err) { variants = []; }

    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var stockEl = document.querySelector('[data-stock]');
    var submit = form.querySelector('[data-add]');
    var dimEl = document.querySelector('[data-spec-dimensions]');

    function currentOptions() {
      return Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]'),
        function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        }
      );
    }

    function sync() {
      var chosen = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return chosen[i] == null || opt === chosen[i]; });
      });
      if (!match) return;

      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price;
      // Must be assigned unconditionally: a variant with no recorded dimension
      // was inheriting the previously selected variant's measurement.
      if (dimEl) dimEl.textContent = match.dimensions || '—';

      // Show the chosen variant's own photograph, and move the thumbnail
      // highlight with it — revealing the strip if that thumb was collapsed.
      if (match.image) {
        var vThumb = null;
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          if (!vThumb && t.getAttribute('data-full') === match.image) vThumb = t;
        });
        if (vThumb) {
          if (vThumb.hasAttribute('data-extra') && thumbStrip &&
              thumbStrip.getAttribute('data-collapsed') !== 'false' && moreBtn) {
            moreBtn.click();
          }
          showMedia(vThumb);
        } else if (main) {
          main.src = match.image;
          main.alt = match.imageAlt || '';
          document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
            t.setAttribute('aria-current', 'false');
          });
        }
      } else if (main) {
        // No photograph for this variant: fall back to the product's own
        // image rather than leaving the previous variant's picture up, which
        // would show the wrong item.
        main.src = featuredSrc;
        main.alt = featuredAlt;
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', String(t.getAttribute('data-full') &&
            main.src.indexOf(t.getAttribute('data-full').replace(/^https?:/, '')) !== -1));
        });
      }

      if (stockEl) {
        stockEl.classList.toggle('stock--out', !match.available);
        var label = stockEl.querySelector('[data-stock-label]');
        if (label) label.textContent = match.available ? stockEl.dataset.inLabel : stockEl.dataset.outLabel;
      }
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available
          ? submit.dataset.addLabel + ' — ' + match.pricePlain
          : submit.dataset.soldLabel;
      }

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    }

    // Thumbnail -> variant. Selecting the radios and letting sync() run keeps
    // one code path in charge of price, stock, dimensions and the URL.
    selectVariantByImage = function (imageUrl) {
      if (!imageUrl) return;
      var match = variants.find(function (v) { return v.image === imageUrl; });
      if (!match) return;                     // a gallery shot with no variant
      var changed = false;
      form.querySelectorAll('[data-option-index]').forEach(function (group, i) {
        var want = match.options[i];
        group.querySelectorAll('input[data-option-value]').forEach(function (input) {
          if (input.value === want && !input.checked) { input.checked = true; changed = true; }
        });
      });
      if (changed) sync();
    };

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-value]')) sync();
    });
    sync();
  }


  /* Saved items ------------------------------------------------------------
     Per-browser, stored in localStorage. Every read and write is wrapped:
     Safari private mode and "block site data" throw on access rather than
     returning null, and a thrown error here would take the rest of the file
     with it. A visitor with storage blocked simply gets no wishlist. */
  var WISH_KEY = 'melange:saved';

  function wishRead() {
    try {
      var raw = window.localStorage.getItem(WISH_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (err) { return []; }
  }

  function wishWrite(list) {
    try { window.localStorage.setItem(WISH_KEY, JSON.stringify(list)); return true; }
    catch (err) { return false; }
  }

  function wishHas(handle) { return wishRead().indexOf(handle) !== -1; }

  function wishToggle(handle) {
    var list = wishRead();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    wishWrite(list);
    return i === -1;
  }

  function wishPaint() {
    var list = wishRead();

    // Header entry point stays hidden until something is saved, so an empty
    // wishlist never adds a dead icon to the header.
    var link = document.querySelector('[data-wish-link]');
    var count = document.querySelector('[data-wish-count]');
    if (link) link.hidden = list.length === 0;
    if (count) count.textContent = String(list.length);

    document.querySelectorAll('[data-wish]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wish')) !== -1;
      btn.setAttribute('aria-pressed', String(on));
      btn.classList.toggle('wish--on', on);
      var label = btn.querySelector('[data-wish-label]');
      if (label) label.textContent = on ? btn.dataset.onLabel || 'Saved'
                                        : btn.dataset.offLabel || 'Save for later';
    });

    var grid = document.querySelector('[data-wish-grid]');
    if (grid) {
      var shown = 0;
      grid.querySelectorAll('[data-wish-item]').forEach(function (item) {
        var on = list.indexOf(item.getAttribute('data-wish-item')) !== -1;
        item.style.display = on ? '' : 'none';
        if (on) shown++;
      });
      var empty = document.querySelector('[data-wish-empty]');
      if (empty) empty.hidden = shown > 0;
      // A handle can go stale when a product is archived or renamed; drop any
      // that no longer has a card so the count never overstates the list.
      if (shown !== list.length) {
        var live = list.filter(function (h) {
          return grid.querySelector('[data-wish-item="' + h + '"]');
        });
        if (live.length !== list.length) { wishWrite(live); wishPaint(); }
      }
    }
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-wish]');
    if (toggle) {
      e.preventDefault();
      wishToggle(toggle.getAttribute('data-wish'));
      wishPaint();
      return;
    }
    var remove = e.target.closest('[data-wish-remove]');
    if (remove) {
      e.preventDefault();
      wishToggle(remove.getAttribute('data-wish-remove'));
      wishPaint();
    }
  });

  // Another tab may have changed the list.
  window.addEventListener('storage', function (e) {
    if (e.key === WISH_KEY) wishPaint();
  });

  wishPaint();

  /* Quantity stepper ------------------------------------------------------ */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.step === 'up' ? 1 : -1;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
})();
